import { render, staticRenderFns } from "./DeleteDeviceModal.vue?vue&type=template&id=4a97574a"
import script from "./DeleteDeviceModal.vue?vue&type=script&lang=js"
export * from "./DeleteDeviceModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports